import React, { useState } from "react";

export default function EmiCalculator() {
  const [principal, setPrincipal] = useState(5000);
  const [rate, setRate] = useState(0.25); // Daily interest rate in %
  const [time, setTime] = useState(70); // Days
  const [fee, setFee] = useState(10); // Processing fee %

  const amount = Number(principal);

  // Interest for selected tenure
  const interest = (amount * rate * time) / 100;

  // Total repayment amount
  const total = amount + interest;

  // Processing fee amount
  const processingFee = (amount * fee) / 100;

  // SAME APR FORMULA AS LoanCal
  const interestFor30Days = (amount * rate * 30) / 100;

  const apr =
    ((processingFee + interestFor30Days) / amount) *
    (365 / 30) *
    100;

  return (
    <section className="bg-gray-100 py-20 px-4">
      <div className="max-w-5xl mx-auto text-center mb-10">
        <h4 className="text-2xl sm:text-3xl lg:text-4xl font-bold leading-snug">
          <span>Quickly </span>
          <span className="ms-text-secondary">
            Calculate Your EMI
          </span>
        </h4>

        <p className="text-gray-600 mt-3">
          Estimate your repayment amount instantly by adjusting the
          loan amount and tenure sliders.
        </p>
      </div>

      <div className="bg-orange-500 rounded-2xl p-6 sm:p-8 shadow-xl max-w-4xl mx-auto">
        {/* Loan Amount */}
        <div className="mb-6">
          <div className="flex justify-between text-white font-medium mb-2">
            <span>Loan Amount</span>
            <span>₹{amount.toLocaleString()}</span>
          </div>

          <input
            type="range"
            min="5000"
            max="100000"
            step="1000"
            value={principal}
            onChange={(e) => setPrincipal(Number(e.target.value))}
            className="w-full accent-white"
          />

          <div className="flex justify-between text-xs text-white mt-1">
            <span>₹5,000</span>
            <span>₹1,00,000</span>
          </div>
        </div>

        {/* Tenure */}
        <div className="mb-6">
          <div className="flex justify-between text-white font-medium mb-2">
            <span>Tenure (Days)</span>
            <span>{time}</span>
          </div>

          <input
            type="range"
            min="70"
            max="365"
            value={time}
            onChange={(e) => setTime(Number(e.target.value))}
            className="w-full accent-white"
          />

          <div className="flex justify-between text-xs text-white mt-1">
            <span>70 Days</span>
            <span>365 Days</span>
          </div>
        </div>

        {/* Interest Rate */}
        <div className="mb-6">
          <div className="flex justify-between text-white font-medium mb-2">
            <span>Interest Rate (%)</span>
            <span>{rate}%</span>
          </div>

          <input
            type="range"
            min="0.25"
            max="1"
            step="0.25"
            value={rate}
            onChange={(e) => setRate(Number(e.target.value))}
            className="w-full accent-white"
          />

          <div className="flex justify-between text-xs text-white mt-1">
            <span>0.25%</span>
            <span>1%</span>
          </div>
        </div>

        {/* Processing Fee */}
        <div className="mb-8">
          <div className="flex justify-between text-white font-medium mb-2">
            <span>Processing Fee (%)</span>
            <span>{fee}%</span>
          </div>

          <input
            type="range"
            min="5"
            max="10"
            step="0.5"
            value={fee}
            onChange={(e) => setFee(Number(e.target.value))}
            className="w-full accent-white"
          />

          <div className="flex justify-between text-xs text-white mt-1">
            <span>5%</span>
            <span>10%</span>
          </div>
        </div>

        {/* Result Card */}
        <div className="bg-[#072c4c] p-6 rounded-xl text-white">
          <div className="grid grid-cols-2 gap-4 mb-4">
            <div className="bg-white text-gray-800 p-4 rounded-lg text-center">
              <p className="text-sm">Repay Amount</p>
              <p className="font-bold text-blue-700 text-lg">
                ₹{total.toFixed(2)}
              </p>
            </div>

            <div className="bg-white text-gray-800 p-4 rounded-lg text-center">
              <p className="text-sm">Tenure</p>
              <p className="font-bold text-blue-700 text-lg">
                {time} Days
              </p>
            </div>
          </div>

          <div className="grid grid-cols-2 gap-4">
            <div className="bg-white text-gray-800 p-4 rounded-lg text-center">
              <p className="text-sm">Processing Fee</p>
              <p className="font-bold text-red-500 text-xl">
                {fee}%
              </p>
            </div>

            <div className="bg-white text-gray-800 p-4 rounded-lg text-center">
              <p className="text-sm">APR</p>
              <p className="font-bold text-red-500 text-xl">
                {apr.toFixed(2)}%
              </p>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}